module.exports = __webpack_public_path__ + "static/media/rocket-launch.91c36a9d.svg";